import { PureComponent, ReactNode } from 'react';
import { track } from '../tracking';
import { getGenieSetting } from '../store/selectors/session';
import { GlobalState } from '../store/reducers';
import { connect } from 'react-redux';
import { AntTooltip } from '../components/common/AntTooltip';

type State = {
    isV2: boolean;
};

const LS_KEY_ABHA_FLOW = 'isNewAbhaFlow';

export const isAbhaV2 = (): boolean => true;

class ToggleAbhaFlowVersion extends PureComponent<
    { isAbdmEnabled: boolean; showText?: boolean; iconHeight?: string; showBorder?: boolean },
    State
> {
    state: State = {
        isV2: isAbhaV2(),
    };

    onToggle = (): void => {
        const { isV2 } = this.state;
        track('TOGGLE_ABHA_FLOW', { isV2: (!isV2).toString() });
        localStorage.setItem(LS_KEY_ABHA_FLOW, (!isV2).toString());
        this.setState({ isV2: !isV2 });
        window.location.reload();
    };

    render(): ReactNode {
        const { isAbdmEnabled, showText, iconHeight, showBorder } = this.props;

        if (!isAbdmEnabled) {
            return null;
        }

        const { isV2 } = this.state;

        return (
            <div
                style={{
                    color: '#215FFF',
                    border: showBorder ? '1px solid #215FFF' : 'none',
                    borderRadius: '0.5rem',
                    fontSize: '13px',
                    fontWeight: 700,
                    cursor: 'pointer',
                    paddingLeft: '0.5rem',
                    paddingRight: '0.5rem',
                    paddingTop: '0.375rem',
                    paddingBottom: '0.375rem',
                    lineHeight: '1.125rem',
                }}
                className="flex items-center space-x-8 min-w-max h-42"
                onClick={this.onToggle}
            >
                {showText ? (
                    <svg
                        className="min-w-24 w-24 h-24 p-4"
                        xmlns="http://www.w3.org/2000/svg"
                        height={iconHeight || '1em'}
                        viewBox="0 0 512 512"
                    >
                        <path
                            d="M304 24c0 13.3 10.7 24 24 24H430.1L207 271c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l223-223V184c0 13.3 10.7 24 24 24s24-10.7 24-24V24c0-13.3-10.7-24-24-24H328c-13.3 0-24 10.7-24 24zM72 32C32.2 32 0 64.2 0 104V440c0 39.8 32.2 72 72 72H408c39.8 0 72-32.2 72-72V312c0-13.3-10.7-24-24-24s-24 10.7-24 24V440c0 13.3-10.7 24-24 24H72c-13.3 0-24-10.7-24-24V104c0-13.3 10.7-24 24-24H200c13.3 0 24-10.7 24-24s-10.7-24-24-24H72z"
                            fill="currentColor"
                        />
                    </svg>
                ) : (
                    <AntTooltip content={`Switch to ${isV2 ? 'Old' : 'New'} ABHA flow`}>
                        <svg
                            className="min-w-24 w-24 h-24 p-4"
                            xmlns="http://www.w3.org/2000/svg"
                            height={iconHeight || '1em'}
                            viewBox="0 0 512 512"
                        >
                            <path
                                d="M304 24c0 13.3 10.7 24 24 24H430.1L207 271c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l223-223V184c0 13.3 10.7 24 24 24s24-10.7 24-24V24c0-13.3-10.7-24-24-24H328c-13.3 0-24 10.7-24 24zM72 32C32.2 32 0 64.2 0 104V440c0 39.8 32.2 72 72 72H408c39.8 0 72-32.2 72-72V312c0-13.3-10.7-24-24-24s-24 10.7-24 24V440c0 13.3-10.7 24-24 24H72c-13.3 0-24-10.7-24-24V104c0-13.3 10.7-24 24-24H200c13.3 0 24-10.7 24-24s-10.7-24-24-24H72z"
                                fill="currentColor"
                            />
                        </svg>
                    </AntTooltip>
                )}

                {showText && <div>Switch to {isV2 ? 'Old' : 'New'} ABHA flow</div>}
            </div>
        );
    }
}

export default connect((state: GlobalState) => ({
    isAbdmEnabled: getGenieSetting(state, 'abdm') as boolean,
}))(ToggleAbhaFlowVersion);
